/**
 * Checks whether the user interacted with an interactive element within a row.
 * @param row - The row with which the user interacted with.
 * @param target - The target element of the interaction.
 * @returns true if the target is interactive, false otherwise.
 */
export function isTargetInteractive(
  row: Element,
  target: HTMLElement | SVGElement,
): boolean {
  if (row === target) {
    return false;
  }

  const interactiveTags = ['A', 'BUTTON', 'LABEL', 'INPUT', 'SELECT'];

  let currentElement: HTMLElement | SVGElement | null = target;
  do {
    const hitInteractiveElement =
      currentElement?.getAttribute('tabindex') !== null ||
      interactiveTags.includes(currentElement?.tagName);

    if (hitInteractiveElement) {
      return true;
    }
    currentElement = currentElement?.parentElement;
  } while (currentElement !== row && currentElement !== null);
  return false;
}
